export default __webpack_public_path__ + "static/media/trash.f5b47a94.svg";